module.exports = __webpack_public_path__ + "static/gallery-4-471ebf79b1de8b0f2e4df58275a98de2.jpg";